<script lang="ts">
  import { auth } from '../Firebase'
  import { remove_self } from '../Players/observables'
  import { app_user } from './observables'
  import NavigationButton from '../Navigation/Buttons/NavigationButton.svelte'
</script>

<div id="logout">
  <NavigationButton
    onClick={async () => {
      if ($app_user.state === 'Authed') {
        await $remove_self()
      }
      await auth.signOut()
      document.location.reload()
    }}
    destination="external">Logout</NavigationButton
  >
</div>

<style>
  #logout {
    display: inline;
    justify-self: right;
  }
</style>
